import { render, staticRenderFns } from "./HardSoftConsonantsSchoolPreparing.vue?vue&type=template&id=45469434&lang=pug&"
import script from "./HardSoftConsonantsSchoolPreparing.vue?vue&type=script&lang=js&"
export * from "./HardSoftConsonantsSchoolPreparing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports